import { GuiPermission }	from "@v3/geko/permission/guiPermission";
import { usePermissions }	from "@v3/geko/permission/usePermissions";

export const useGuiPermission	= (permission:GuiPermission):boolean =>
	GuiPermission.accessAllowed(
		usePermissions(),
		permission
	);
